<template>
  <div class="courses">
    <div class="courses__header-wrapper">
      <h2 class="courses__header-title">Курсы</h2>
      <el-button type="primary" round class="courses__header-create">Создать курс</el-button>
    </div>

    <el-card class="w-height">
      <el-row class="w-full">
        <el-col>
          <div class="courses__search-section">
            <el-select v-model="courseSelect" size="small" class="courses__select">
              <el-option v-for="item in courseOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <div class="courses__input-wrapper">
              <el-input
                v-model="searchInput"
                type="search"
                placeholder="Поиск"
                suffix-icon="el-icon-search"
                size="small"
              >
              </el-input>
            </div>
          </div>
          <div class="common__table-wrapper">
            <table class="common__table">
              <thead>
                <tr>
                  <td>Название</td>
                  <td>Содержание</td>
                  <td>уровень знания языка</td>
                  <td>Статус</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(tr, index) in tableData"
                  :key="tr.id"
                  @click="showCourseInfo(index, tr.id)"
                >
                  <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                    {{ tr.title }}
                  </td>
                  <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                    <ul v-for="(item, i) in tr.description" :key="i">
                      <li>{{ item }}</li>
                    </ul>
                  </td>
                  <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                    {{ tr.score }}
                  </td>
                  <td :class="{ 'common__table-item-is-active': activeIndex === index }">
                    {{ tr.status }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Courses',
  data: () => ({
    courseOptions: ['По имени А-Я'],
    searchInput: '',
    courseSelect: '',
    tableData: [
      {
        title: 'Русский язык как иностранный',
        description: ['Вводно-речевой курс'],
        score: 'А1, А2, В1',
        status: 'Активный',
        id: 1
      },
      {
        title: 'Базовый курс',
        description: [
          'Вводно-речевой курс',
          'Уровень владения языком А1',
          'Уровень владения языком А2',
          'Уровень владения языком B1'
        ],
        score: 'А1, А2, В1',
        status: 'Черновик',
        id: 2
      }
    ],
    activeIndex: null
  }),
  // Todo: отрефакторить на дату с бэка. временно для наглядности
  methods: {
    showCourseInfo(index) {
      this.activeIndex = index
      this.$router.push({ name: 'overview', params: { id: index } })
    }
  }
}
</script>

<style scoped lang="scss">
.courses {
  height: 100%;

  &__header-wrapper {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;

    @include sm-and-down {
      flex-wrap: wrap;
      margin-bottom: 20px;
    }
  }

  &__header {
    &-title {
      margin-bottom: 0;
      font-weight: bold;
      font-size: 24px;
      letter-spacing: 0.35px;
      color: $luchmara;

      @include sm-and-down {
        width: 100%;
        margin-bottom: 40px;
      }
    }
  }

  &__input-wrapper {
    width: 420px;
  }

  &__search-section {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    @include sm-and-down {
      flex-wrap: wrap;
    }
  }

  &__select {
    @include sm-and-down {
      width: 100%;
      margin-bottom: 20px;
    }
  }
}

::v-deep .el-input__inner {
  border-radius: 20px;
  padding-left: 14px;
}
</style>
